import { closeAllDialogs } from "fe2/Actions/ActionDialog";
import { connect } from "react-redux";
import { Layout } from "UIKit";

const mapStateToProps = state => {
  const needShowOverlay = (state.dialog.isVisible || state.fetchingCounter.counter > 0);
  return {
    root: state.urls.root,
    needShowOverlay,
    currentAccount: state.currentAccount,
    routePath: state.routing.locationBeforeTransitions.pathname,
    isDialogOverlay: state.dialog.isOverlay
  };
};


const mapDispatchToProps = dispatch => ({
  onRouteClick() {
    dispatch(closeAllDialogs());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Layout);